/**
 * 拼接url参数
 * @description 将params拼接至link
 * @param {string} link 原始链接
 * @param {Record<string, unknown>} [params] query字典
 */
export function concatURI(link, params) {
    if (!params)
        return link;
    const [pureUrl, searchParams] = link.split('?');
    if (!pureUrl)
        return '';
    const query = [], qs = new URLSearchParams(searchParams), qsDic = {};
    qs.forEach((v, k) => {
        qsDic[k] = v;
    });
    Object.assign(qsDic, params);
    for (const [key, value] of Object.entries(qsDic)) {
        let val = value;
        if (typeof value !== 'string') {
            val = value === null || value === void 0 ? void 0 : value.toString();
        }
        if (val != null) {
            query.push(`${key}=${encodeURIComponent(val)}`);
        }
    }
    return pureUrl + '?' + query.join('&');
}
/**
 * 休眠
 * @param {number} time 等待时间
 * @return {*}  {Promise<void>}
 */
export function sleep(time) {
    return new Promise((resolve) => {
        setTimeout(resolve, time);
    });
}
/**
 * 生成随机id
 */
export function genId() {
    return Math.random().toString(36).slice(2);
}
/**
 * 添加符号
 * @example
 * ```js
 * // 将数字转换为货币值
 * addComma(10000) //=>1,000
 * ```
 * @param {(number | string)} value 原始值
 * @param {number} [splitNum=3] 几个一分割
 * @param {comma} [comma=,] 分割的符号
 */
export function addComma(value, splitNum = 3, comma = ',') {
    const pointsArr = value.toString().split(''), res = pointsArr.slice();
    for (let i = pointsArr.length - splitNum - 1; i >= 0; i -= splitNum) {
        res.splice(i + 1, 0, comma);
    }
    return res.join('');
}
/**
 * 将数组拼接为符串，用symbol链接
 * @description 用于pageview.title
 * @export
 * @param {((string | undefined)[])} arr
 * @param {string} [symbol='-'] 拼接符号
 */
export function concatWithSymbol(arr, symbol = '-') {
    let res = '', lastChar = '';
    arr.forEach((t) => {
        if (t != null) {
            lastChar = res.charAt(res.length - 1);
            if (lastChar && lastChar !== symbol) {
                res += symbol + t;
            }
            else {
                res += t;
            }
        }
    });
    return res;
}
/**
 *是否为https链接
 */
export function isSafeURI(url) {
    return typeof url === 'string' && url.startsWith('https');
}
/**
 * 是否为图片
 * @export
 * @param {string} source 链接
 */
export function isImgSource(source) {
    return /jpg|jpeg|png|gif|webp$/.test(source);
}
/**
 * 找到符合条件的最后一项
 * @template T 数据类型
 * @param {T[]} arr
 * @param {(t: T) => boolean} fn
 */
export function findLast(arr, fn) {
    let i = arr.length - 1;
    while (i >= 0) {
        if (fn(arr[i])) {
            return arr[i];
        }
        else {
            i--;
        }
    }
}
/**
 * 递归遍历
 * @template T
 * @param {T} data
 * @param {((item?: T[number], arr?: T, pItem?: T[number]) => void | boolean)} callback
 * @param {string} [key='children']
 * @return {*}  {(T[number] | undefined)}
 */
export function loop(data, callback, key = 'children') {
    let res, pItem;
    function loopEffect(dataItems) {
        var _a;
        for (const item of dataItems) {
            if (callback(item, dataItems, pItem)) {
                res = item;
                break;
            }
            if (((_a = item[key]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                pItem = item;
                res = loopEffect(item[key]);
                if (res) {
                    break;
                }
            }
        }
        return res;
    }
    return loopEffect(data);
}
/**
 * 等待图片加载完毕
 * @param {HTMLImageElement} img
 */
export function imgLoaded(img) {
    return new Promise((resolve, reject) => {
        if (!img.complete) {
            img.onload = () => {
                resolve();
            };
            img.onerror = reject;
        }
        else {
            resolve();
        }
    });
}
